<template>
  <div class="home">
    <div class="cardWrapper">
      <div class="cardRow cardTop">
        <router-link class="sala" :to="{ name: 'Guide'}"><img alt="Hoja de sale" src="../assets/bg_link_hoja_de_sala.png"/></router-link>
      </div>
      <div class="cardRow cardCenter"></div>
      <div class="cardRow cardBottom">
        <router-link class="expo" :to="{ name: 'Exhibition'}"><img alt="Hoja de sale" src="../assets/bg_link_expo.png"/></router-link>
      </div>
  </div>
    <!-- <div class="card">
      <router-link class="sala" :to="{ name: 'Guide'}"><img alt="Hoja de sale" src="../assets/bg_link_hoja_de_sala.png"/></router-link>
      <br />
      <router-link class="expo" :to="{ name: 'Exhibition'}"><img alt="Hoja de sale" src="../assets/bg_link_expo.png"/></router-link>
    </div> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">

$debug: false;

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.home {
  margin-top: 70px;
  display: flex;
}

.cardWrapper {
  background-image: url("../assets/tarjeton.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  @if $debug == true {
    // border: solid 1px #0000FF;
    // background-color: beige;
  }
  width: 1000px;
  aspect-ratio: 16 / 10;
  margin: 2%;
  // height: 600px;
}
.cardRow {
  height: 33%;
  display: flex;
  align-items: center;
    justify-content: center;

    .sala img {
    // margin-top: 2.1rem;
    filter: drop-shadow(0px 0px 6px #7c2f2f);
    width: 90%;
    margin: 0;
  }

  .expo img {
    // margin-top: 2.1rem;
    filter: drop-shadow(0px 0px 6px #ac6f3b);
    margin: 0;
    width: 90%;
  }
}

.cardTop {
  @if $debug == true {
    background-color: rgb(204, 204, 9);
  }
  flex: 1;
}
.cardMiddle {
  @if $debug == true {
    background-color: rgb(37, 179, 108);
  }
}
.cardBottom {
  @if $debug == true {
    background-color: rgb(204, 142, 201);
  }
}

#navbar {
  @if $debug == true {
    border: solid 1px #0000FF;
    background-color: beige;
  }

  height: 8vh;
  padding: 1em;
}

.home {
  display: flex;
  justify-content: center;
}

.card {
  border: solid 1px #0000FF;
  background-image: url("../assets/tarjeton.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  // width: 50rem;
  // height: 30rem;
  padding-top: 10px;

  aspect-ratio: 16 / 10;

  .sala img {
    // margin-top: 2.1rem;
    filter: drop-shadow(0px 0px 6px #7c2f2f);
    margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  }

  .expo img {
    margin-top: 16.3rem;
    filter: drop-shadow(0px 0px 6px #ac6f3b);
    position: absolute;
    bottom: 10px;
  }
}

@include respond-above(lg) {
  .card  {
    width: 50rem;
    margin-left: 1em;
    margin-right: 1em;
  }
}

@include respond-between(md, lg) {
  .card  {
    width: 50rem;
    margin-left: 1em;
    margin-right: 1em;
  }
}

@include respond-below(md) {
  .card  {
    width: 100%;
    margin-left: 0.5em;
    margin-right: 0.5em;
  }
}

#nav {
  padding: 0px;

  a {
    font-size: 1.2em;
    font-weight: bold;
    color: #2c3e50;
    text-decoration: none;

    &.router-link-exact-active {
      color: #631c2c;
    }
  }

  a:hover {
    color: #631c2c;
  }
}

/* .carousel { height: 100%; } */

.carousel-cell {
  width: 100%; /* full width */
  height: 574px;
  /* background: #222; */
  /* center images in cells with flexbox */
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
  padding-bottom: 4px;
}

.carousel-cell img {
  filter: drop-shadow(0px 4px 4px #666669);
}

.carousel-cell img:hover {
  filter: drop-shadow(0px 4px 4px #69303e);
}

</style>
